import React from 'react'
import { ExpenseDetailsSourceIcon } from 'src/components/ExpenseDetailsSourceIcon/ExpenseDetailsSourceIcon'
import { ExpenseDetailsModel } from 'src/models/transaction.models'

import * as styles from './ExpenseDetailStaticView.style'

interface ExpenseDetailStaticViewProps {
  expenseDetail: ExpenseDetailsModel
  className?: string
}

const ExpenseDetailStaticView: React.FC<ExpenseDetailStaticViewProps> = (
  props,
): React.ReactElement => {
  const { expenseDetail } = props
  const appliedByAutomation =
    !!expenseDetail.ruleId || expenseDetail.generatedByPrediction

  return (
    <div className={props.className} css={styles.container}>
      <span css={styles.categoryLabel}>
        {expenseDetail.categoryName}
        {appliedByAutomation && (
          <ExpenseDetailsSourceIcon
            generatedByPrediction={expenseDetail.generatedByPrediction}
            errorMessage={expenseDetail.errorMessage}
            cssProps={styles.automationIcon}
          />
        )}
      </span>
      <span css={styles.categoryValue}>{expenseDetail.labelName}</span>
    </div>
  )
}

export default ExpenseDetailStaticView
